/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator>): AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator(), model);
        AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator>): AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator.newInstance(<AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityImpactMetricAvailabilityImpactV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Impact metric(s) availability impact to include
     */
    availability_impact_v31: Array<models.CvssV31ImpactMetrics>;

}
